import { useState } from 'react';
import { discussionTopics } from '@/mocks/home';

const stances = [
  { id: 'original', label: '原版派', note: '经典就该留在记忆里，翻拍很难超越当年的灵气与氛围。' },
  { id: 'remake', label: '情怀派', note: '愿意为那份熟悉的名字再看一次，哪怕它只是借了个壳。' },
  { id: 'neutral', label: '旁观派', note: '把它当成一个时代现象来观察，比争论好坏更有意思。' },
];

export default function DiscussionSection() {
  const [stance, setStance] = useState<string | null>(null);
  const current = stances.find((s) => s.id === stance);

  return (
    <section id="discussion" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="reveal max-w-2xl">
          <span className="text-primary-600 font-label text-sm tracking-wide">话题广场</span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            关于两代作品，大家都在聊什么
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed">
            这些是围绕原版与 3D 版最常见的讨论方向，也代表了老影迷与新一代观众的不同视角。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {discussionTopics.map((topic, index) => (
            <div
              key={topic.label}
              className="reveal bg-background-100/70 border border-background-200/80 rounded-lg p-5 md:p-6"
              style={{ animationDelay: `${index * 60}ms` }}
            >
              <div className="flex items-center gap-2">
                <span className="px-2.5 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-[11px] font-label">
                  {topic.tag}
                </span>
                <span className="font-heading text-sm md:text-base font-bold text-foreground-950">
                  {topic.label}
                </span>
              </div>
              <p className="mt-3 text-foreground-600 text-xs md:text-sm leading-relaxed">{topic.text}</p>
            </div>
          ))}
        </div>

        <div className="reveal mt-8 bg-background-950 rounded-lg p-6 md:p-8">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div>
              <p className="font-heading text-lg md:text-xl font-bold text-background-50">你是哪一派？</p>
              <p className="mt-1 text-background-50/65 text-xs md:text-sm">
                选一个最接近你的立场，看看它对应的说法。
              </p>
            </div>
            <div className="flex flex-wrap gap-2">
              {stances.map((item) => (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => setStance(item.id)}
                  aria-pressed={stance === item.id}
                  className={`px-4 py-2 rounded-md text-xs md:text-sm font-label whitespace-nowrap cursor-pointer transition-colors ${
                    stance === item.id
                      ? 'bg-accent-500 text-foreground-950'
                      : 'bg-background-50/10 text-background-50 hover:bg-background-50/20'
                  }`}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>

          <div
            className={`mt-5 flex items-start gap-3 rounded-lg p-4 transition-opacity duration-300 ${
              current ? 'bg-background-50/10 opacity-100' : 'opacity-0'
            }`}
          >
            <span className="w-7 h-7 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-500/20 text-accent-300">
              <i className="ri-chat-quote-line text-sm" />
            </span>
            <p className="text-background-50/85 text-xs md:text-sm leading-relaxed">
              {current?.note ?? ''}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}